<template>
  <div>
    <!-- :title="
                moduleType==1?'保洁服务':
                moduleType==2?'保安服务':
                moduleType==3?'陪护服务':
                moduleType==4?'运送服务':
                moduleType==5?'投诉监督':
                moduleType==6?'用车服务':
                moduleType==7?'报修服务':
                moduleType==8?'设备维保服务':
                moduleType==9?'设备巡检':
                moduleType==10?'区域巡检':''
            " -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      top="60px"
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
      append-to-body
      :modal-append-to-body="false"
      v-loading="loading < 40"
    >
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            {{ isEdit ? '编 辑' : '查 看' }}
          </span>
          <i
            class="el-icon-full-screen"
            style="margin-right: 20px; position: relative; top: -1px"
            @click="dialogFull = !dialogFull"
          ></i>
        </div>
      </template>
      <div v-if="dialogVisible">
        <div style="display: flex; justify-content: space-between">
          <div style="font-size: 20px">
            <!-- <span  style="font-size:20px;font-weight:bold;">{{ orderDetailForm.code }}</span> -->
            <span style="font-size: 20px; font-weight: bold">服务单号:</span
            >{{ orderDetailForm.code }}
            <span style="font-size: 20px; font-weight: bold">服务类型:</span
            >{{ orderDetailForm.moduleTypeName }}
            <!-- <span style="font-size:20px;font-weight:bold;">工单名称:</span> -->
            <!-- <span style="font-size:20px;">
                    {{ orderDetailForm.orderName }}
                </span> -->
            <el-tag type="success">{{ orderDetailForm.statusName }}</el-tag>
          </div>
          <div v-if="!isEdit">
            <!-- opensettingSynergy -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openAssignDialog(1)">派单</el-button> -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openGrabSingleDialog(2)">抢单</el-button> -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openConfirmDialog">确认</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="opensettingSynergy">协同人</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openRobOrderDialog">抢单</el-button> -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openRobOrderDialog(3)">接受</el-button> -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openComplaintDialog(4)">转办</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openStartOrderDialog(5)">开始</el-button> -->
            <!-- 延迟 恢复 -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openDelayDialog(6)">延迟</el-button>
                    <el-button style="margin:0 10px"  type="primary" @click="openRecoverDialog(7)">恢复</el-button> -->

            <!-- <el-button style="margin:0 10px"  type="primary" @click="openFinishDialog(8)">完成</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openEvaluateDialog(9)">评价</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openVisitDialog">回访</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openPrintDialog">打印</el-button> -->
            <!-- <el-button style="margin:0 10px"  @click="openCancelDialog(12)">取消</el-button> -->
            <!-- 报事 报修 外委 -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openRepairsDialog(13)">报修</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openScrapDialog(14)">报废</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openOutsourcingDialog(15)">外委</el-button> -->

            <span v-for="item in orderActiveButton" :key="item">
              <!-- <el-button style="margin:0 10px" v-if="item.dictValue==1" type="primary" @click="openAssignDialog(1)">{{ item.dictKey }}</el-button>
                    <el-button style="margin:0 10px" v-if="item.dictValue==2" type="primary" @click="openRobOrderDialog(2)">{{ item.dictKey }}</el-button> -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 1"
                type="primary"
                @click="openAssignDialog(1)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 2"
                type="primary"
                @click="openGrabSingleDialog(2)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 3"
                type="primary"
                @click="openRobOrderDialog(item.dictKey)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 4"
                type="primary"
                @click="openComplaintDialog(4)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 5"
                type="primary"
                @click="openStartOrderDialog(5)"
                >{{ item.dictKey }}</el-button
              >
              <!-- 延迟 恢复 -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 6"
                type="primary"
                @click="openDelayDialog(item.dictKey)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 7"
                type="primary"
                @click="openRecoverDialog(7)"
                >{{ item.dictKey }}</el-button
              >

              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 8"
                type="primary"
                @click="openFinishDialog(8)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 9"
                type="primary"
                @click="openEvaluateDialog(9)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 10"
                type="primary"
                @click="openVisitDialog"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 11"
                type="primary"
                @click="openPrintDialog(false)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 19"
                type="primary"
                @click="openUrgeDialog"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 16"
                type="primary"
                @click="opensettingSynergy"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 12"
                @click="openCancelDialog(12)"
                >{{ item.dictKey }}</el-button
              >
              <!-- 报事 报修 外委 -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 13"
                type="primary"
                @click="openRepairsDialog(13)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 14"
                type="primary"
                @click="openScrapDialog(item.dictKey)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 15"
                type="primary"
                @click="openOutsourcingDialog(15)"
                >{{ item.dictKey }}</el-button
              >
              <!-- <el-button style="margin:0 10px" v-if="item.dictValue==18" type="primary" @click="openConfirmDialog">{{ item.dictKey }}</el-button> -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 18"
                type="primary"
                @click="openConfirmDialog"
                >{{ item.dictKey }}</el-button
              >
            </span>
            <!-- <span>
              <el-button style="margin: 0 10px" type="primary" @click="openPrintDialog(true)"
                >打印</el-button
              >
            </span> -->
          </div>
        </div>
        <el-divider></el-divider>
        <!-- 工单详情 -->
        <div style="display: flex; justify-content: space-between">
          <div class="order-detail" :style="'height:' + dialogBodyHight + 'px;overflow:scroll;'">
            <avue-form :option="option" v-model="orderDetailForm">
              <template slot="evaluate">
                <div style="width: 250px">
                  <!-- <div>{{evaluateInfo.content}}</div> -->
                  <!-- <input type="text" placeholder="666666"/> -->
                  <div
                    v-for="(item, index) in evaluateDetailList"
                    :key="index"
                    style="overflow: hidden"
                  >
                    <div style="display: inline-block; width: 5rem; float: left">
                      {{ getEvaluateType(item.target) }}:
                    </div>
                    <div
                      style="
                        display: inline-block;
                        float: left;
                        height: 2rem;
                        box-sizing: border-box;
                        padding: 0.4rem 0;
                      "
                    >
                      <el-rate
                        v-model="item.level"
                        disabled
                        text-color="#ff9900"
                        score-template="{value}"
                      >
                      </el-rate>
                    </div>
                    <div style="display: inline-block; float: left; color: #f7ba2a">
                      {{ tag(item.level) }}
                    </div>
                  </div>
                </div>
              </template>
              <template slot="serviceProject">
                <el-row>
                  <el-col span="24" v-for="(item, index) in checkedServiceProjectData" :key="item">
                    <el-tag style="margin-right: 10px; margin-bottom: 5px">
                      {{ item.itemName }} | {{ item.serviceContent }}
                      <span>{{ item.score }}分</span>
                      <span style="margin: 0 15px; color: #f99b34"
                        >￥{{ item.price ? tool.money_format_allowvoid(item.price) : '0.00' }}</span
                      ><span>&times;{{ item.consumeNum }}</span>
                    </el-tag>
                    <el-tag
                      @click="openSelectServiceProject"
                      v-if="checkedServiceProjectData.length == index + 1"
                      ><i class="el-icon-edit"></i
                    ></el-tag>
                  </el-col>
                  <el-col
                    span="24"
                    v-if="checkedServiceProjectData.length == 0 && serviceProjectEdit"
                  >
                    <el-tag @click="openSelectServiceProject"><i class="el-icon-edit"></i></el-tag>
                  </el-col>
                </el-row>
                <!-- <div>
                     <el-tag v-for="item in checkedServiceProjectData" :key="item" style="margin-right:10px;margin-bottom:5px;">
                            {{item.itemName}} | {{item.serviceContent}} <span>{{ item.score }}分</span>
                            {{item.consumeNum}}
                      </el-tag>
                      <el-tag @click="openSelectServiceProject" v-if="serviceProjectEdit"><i class="el-icon-edit"></i></el-tag>
                  </div> -->
              </template>
              <template slot="attachList">
                <vupload :fileList.sync="orderDetailForm.attachList" :disabled="true"></vupload>
              </template>
              <template slot="finishInformation">
                <div>
                  <ServiceProject
                    :orderDetailForm="orderDetailForm"
                    :checked="checkedServiceProjectData"
                    @refresh="serviceProjeptRefresh"
                    :isEdit="isEdit"
                    ref="ServiceProject"
                  ></ServiceProject>
                  <div>
                    <Consumables
                      :form="orderDetailForm"
                      :evaluateTypeList="evaluateTypeList"
                      :evaluateDetailList.sync="evaluateDetailList"
                      ref="Consumables"
                      @handleClose="handleClose"
                      :isEdit="isEdit"
                    ></Consumables>
                  </div>
                </div>
              </template>
            </avue-form>
          </div>
          <div class="course" :style="'height:' + dialogBodyHight + 'px;overflow:scroll;'">
            <el-steps process-status direction="vertical" space="20%" :active="1">
              <el-step
                v-for="(item, index) in courseList"
                :key="item"
                :title="item.orderActionName"
              >
                <template slot="icon">
                  <div class="step-icon">
                    {{ courseList.length - index }}
                  </div>
                </template>
                <template slot="description">
                  <div>
                    {{ item.createTime }}
                    <!-- <el-tag
                                size="mini"
                                type="warning"
                                effect="dark"
                                style="cursor: pointer;"
                                @click="clickDetail(item)"
                                >
                                    详情 <span :class="item.showDetail ? 'el-icon-arrow-up':'el-icon-arrow-down'">
                                </span></el-tag> -->
                  </div>
                  <div>
                    <div>
                      操作人:{{ item.operateUser
                      }}<span v-if="item.phone">{{ '(' + item.phone + ')' }}</span>
                    </div>
                    <div>内容:{{ item.title + ' ' + item.content }}</div>
                    <div class="img">
                      <el-image
                        v-for="img in item.imgUrlData"
                        :key="img"
                        style="width: 50px; height: 50px; margin-right: 10px"
                        :src="img.link"
                        :z-index="10000"
                        :preview-src-list="[img.link]"
                        :fit="cover"
                      ></el-image>
                    </div>
                    <div v-for="file in item.fileList" :key="file">
                      <div style="color: #409eff" @click="downloadFile(file)">
                        {{ file.originalName }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>

        <el-dialog
          title="打印"
          :visible.sync="printDialog"
          width="60%"
          :before-close="closePrintDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <div style="width: 100" id="print">
            <table width="100%" border="1" style="border-collapse: collapse">
              <tr>
                <td
                  class="title-name add-width"
                  style="font-weight: bold; width: 100px; line-height: 40px; height: 40px"
                >
                  名称:
                </td>
                <td colspan="3">{{ printForm.orderName }}</td>
                <td class="title-name">编号:</td>
                <td>{{ printForm.code }}</td>
              </tr>
              <tr>
                <td class="title-name">需求人:</td>
                <td>{{ printForm.contactName }}</td>
                <td class="title-name">电话:</td>
                <td>{{ printForm.requireManPhone }}</td>
                <td class="title-name">部门:</td>
                <td>{{ printForm.requireManDept }}</td>
              </tr>
              <tr>
                <td class="title-name">地址:</td>
                <td colspan="5">{{ printForm.address }}</td>
              </tr>
              <tr>
                <td class="title-name">描述:</td>
                <td colspan="5" class="add-height">{{ printForm.description }}</td>
              </tr>
              <tr>
                <td class="title-name">服务人员:</td>
                <td>{{ printForm.serviceStaff }}</td>
                <td class="title-name">电话:</td>
                <td>{{ printForm.serviceStaffPhone }}</td>
                <td class="title-name">班组:</td>
                <td>{{ printForm.groupName }}</td>
              </tr>
              <tr>
                <td class="title-name">现场记录:</td>
                <td colspan="5" class="add-height">{{ printForm.fieldServiceRecord }}</td>
              </tr>
              <tr>
                <td class="title-name">完工记录:</td>
                <td colspan="5" class="add-height">{{ printForm.completionRecord }}</td>
              </tr>
            </table>
          </div>
          <div style="display: flex; justify-content: flex-end; margin-top: 20px">
            <el-button type="primary" @click="printSubmit">打印</el-button>
            <el-button style="margin: 0 20px" @click="printDialog = false">取消</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="报修"
          :visible.sync="repairsDialog"
          width="60%"
          :before-close="closeRepairsDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            v-if="repairsDialog"
            :option="repairsFormOption"
            v-model="repairsForm"
            @submit="repairsFormSubmit"
            @error="repairsFormError"
          >
            <template slot="projectId">
              <el-select v-model="repairsForm.projectId" @change="changeHandler_">
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
            <template slot="areaId">
              <el-select
                v-model="repairsForm.areaId"
                :value="repairsForm.areaId"
                placeholder="请选择需求区域"
                clearable
                ref="addConnectSelect"
              >
                <el-option
                  :value="repairsForm.areaId"
                  show-all-levels
                  :label="repairsForm.areaName"
                >
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="treeProps"
                    :load="editAreaLazyLoadTree"
                    lazy
                    @node-click="editAreaNodeTreeClick_"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </template>
            <template slot="description">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="repairsForm.description"
                >
                </el-input>
                <remarkModel
                  :remark.sync="repairsForm.description"
                  ref="repairsFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="requireMainId">
              <el-select v-model="repairsForm.requireMainId" @change="changeRequireUserHandler_">
                <el-option
                  v-for="(item, index) in requireUserList"
                  :key="index"
                  :label="item.realName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="repairsForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeRepairsDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
      </div>
      <template slot="footer" v-if="isEdit">
        <el-divider></el-divider>
        <div>
          <el-button
            icon="el-icon-circle-plus-outline"
            @click="submitRepaireUpdate"
            size="small"
            type="primary"
            >保 存</el-button
          >
          <el-button
            icon="el-icon-circle-close"
            style="margin-right: 10px"
            size="small"
            @click="handleClose(false)"
            >取 消</el-button
          >
        </div>
      </template>
      <!-- <orderAudit></orderAudit> -->
    </el-dialog>
    <!-- 打印 -->
    <Print @handleClose="handleClose" ref="print"></Print>
    <!-- 协同人 -->
    <actionForm @handleClose="handleClose" ref="settingSynergy"></actionForm>
    <!-- 确认 -->
    <comfirmForm @handleClose="handleClose" ref="comfirmForm"></comfirmForm>
    <!-- 催办 -->
    <urgeForm @handleClose="handleClose" ref="urgeForm"></urgeForm>
    <!-- 回访 -->
    <visitForm @handleClose="handleClose" ref="visitForm"></visitForm>
    <!-- 外委 -->
    <Outsourcing @handleClose="handleClose" ref="Outsourcing"></Outsourcing>
    <!-- 开始 -->
    <Start @handleClose="handleClose" ref="start"></Start>
    <!-- 转办 -->
    <Complaint @handleClose="handleClose" ref="complaint" />
    <!-- 完成 -->
    <Finish @handleClose="handleClose" ref="finish" />
    <!-- 编辑服务项目 -->
    <editServiceProject
      :checked="checkedServiceProjectData"
      @refresh="serviceProjeptRefresh"
      ref="editServiceProject"
    ></editServiceProject>
    <!-- 派单 -->
    <Appoint @handleClose="handleClose" ref="Appoint"></Appoint>
    <!-- 抢单 -->
    <GrabSingle @handleClose="handleClose" ref="GrabSingle"></GrabSingle>
    <!-- 取消 -->
    <Cencel @handleClose="handleClose" ref="cencel"></Cencel>

    <!-- 接收 -->
    <Receive @handleClose="handleClose" ref="Receive"></Receive>

    <!-- 报废 -->
    <Scrap @handleClose="handleClose" ref="Scrap"></Scrap>
    <!-- 挂起、延迟 -->
    <Delay @handleClose="handleClose" ref="Delay"></Delay>

    <!-- 恢复 -->
    <Recover @handleClose="handleClose" ref="Recover"></Recover>

    <!-- 评价 -->
    <Evaluate @handleClose="handleClose" ref="Evaluate"></Evaluate>
  </div>
</template>
<script>
import {
  complaintFormOption,
  assignFormOption,
  robOrderFormOption,
  startOrderFormOption,
  cancelFormOption,
  evaluateFormOption,
  visitFormOption,
  delayFormOption,
  recoverFormOption,
  scrapFormOption,
  repairsFormOption,
  outsourcingFormOption,
} from './course-dialog-form-option';

import {
  getprojectList,
  getOrderactionlist,
  getCourseLog,
  getOrderDetail,
  getDictData,
  lazyAreaTree, //懒加载区域树
  getUserListByDepartmentId, //需求人员
  print, //工单打印
  accept, //工单接受
  repairs, //工单报修
  getRemarkList, //获取备注模板
  downloadFile, //下载文件方法
  getServiceProjectByOrderId, //获取服务项目，
  isExecutePermission, //是否展示修改服务项目按钮
} from '@/api/gateservice/order/order-list/order-list';
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary';
import remarkModel from './remark-model';
import { mapGetters } from 'vuex';
import Outsourcing from '../actionForm/outsourcing.vue';
import Start from '../components/general-start';
import vupload from '@/views/components/v-upload';
import actionForm from './course-action-form';
import comfirmForm from '../actionForm/confirm';
import urgeForm from '../actionForm/urge';
import visitForm from '../actionForm/visit';
import Complaint from '../actionForm/complaint';
import Finish from '../repair-logistics/finish';
import editServiceProject from '../repair-logistics/edit-service-project';
import Appoint from '../components/appoint';
import GrabSingle from '../components/grabSingle';
import Print from '../components/print.vue';
import ServiceProject from '../components/serviceProject.vue';
import Consumables from '../components/Consumables.vue';
import Receive from '../components/receive.vue';
import Cencel from '../components/cencel.vue';
import Scrap from '../components/scrap.vue';
import Delay from '../components/delay.vue';
import Recover from '../components/recover.vue';
import Evaluate from '../components/evaluation.vue';
export default {
  components: {
    vupload,
    remarkModel,
    actionForm,
    comfirmForm,
    urgeForm,
    visitForm,
    Outsourcing,
    Start,
    Complaint,
    Finish,
    editServiceProject,
    Appoint,
    GrabSingle,
    Print,
    ServiceProject,
    Consumables,
    Cencel,
    Receive,
    Scrap,
    Delay,
    Recover,
    Evaluate,
  },
  data() {
    return {
      orderRow: {}, //包含所有的基础信息
      isEdit: false,
      dialogBodyHight: 0,
      dialogFull: false,
      evaluateTypeList: [],
      evaluateDetailList: [],
      evaluateInfo: {},
      serviceProjectEdit: false,
      checkedServiceProjectData: [], //服务项目集合
      loading: 0,
      evaluateList: [], //评价表单  --评价对象list
      treeProps: {
        //报修表单 --需求区域树的配置
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      requireUserList: [], //报修表单 --需求人员
      treeFormAreaData: [], //懒加载区域树 --报修表单中
      printLoading: true, //打印加载状态开关
      test: false,
      courseList: [], //获取历程数据
      dialogVisible: false,
      imgUrlData: [], //图片的容器
      fileUrlData: [], //文件的容器
      orderDetailForm: {
        name: '',
      }, //工单详情
      complaintForm: {
        name: '',
      },
      orderId: '', //工单id
      projectId: '', //项目id
      moduleType: '', //服务类型
      // 表单配置
      delayFormOption: delayFormOption, //延迟

      recoverFormOption: recoverFormOption, //恢复

      outsourcingFormOption: outsourcingFormOption, //外委

      scrapFormOption: scrapFormOption, //报废

      repairsFormOption: repairsFormOption, //报修

      complaintFormOption: complaintFormOption,

      assignFormOption: assignFormOption,

      robOrderFormOption: robOrderFormOption,

      startOrderFormOption: startOrderFormOption,

      cancelFormOption: cancelFormOption,

      evaluateFormOption: evaluateFormOption,

      visitFormOption: visitFormOption,
      delayForm: {
        attachList: [],
      },
      recoverForm: {},
      finishForm: {
        attachList: [],
      },
      outsourcingForm: {},
      scrapForm: {
        attachList: [],
      },
      repairsForm: {
        attachList: [],
      },
      complaintForm: {},
      assignForm: {},
      robOrderForm: {},
      startOrderForm: {
        attachList: [],
      },
      cancelForm: {
        attachList: [],
      },
      evaluateForm: {},
      visitForm: {},
      printForm: {},
      // 弹窗控制d
      delayDialog: false, //延迟
      recoverDialog: false, //恢复
      scrapDialog: false, //报废
      outsourcingDialog: false, //外委
      repairsDialog: false, //报修
      complaintDialog: false,
      assignDialog: false,
      robOrderDialog: false,
      startOrderDialog: false,
      cancelDialog: false,
      evaluateDialog: false,
      visitDialog: false,
      receiveDialog: false,
      printDialog: false,
      orderActiveButton: [], //按钮
      orderStatusNameList: [], //工单状态
      groupList: [], //取组下拉框
      orderRequireSourcelist: [], //需求来源列表

      option: {
        column: [],
        labelPosition: 'right',
        labelSuffix: '：',
        labelWidth: 100,
        gutter: 0,
        menuBtn: false,
        submitBtn: false,
        submitText: '提交',
        emptyBtn: true,
        emptyText: '清空',
        menuPosition: 'center',
        disabled: true,
        group: [
          {
            label: '需求信息',
            prop: '1604911406120_70101',
            arrow: true,
            collapse: true,
            display: true,
            column: [
              {
                type: 'select',
                label: '项目名称',
                span: 8,
                rules: [{ required: true }],
                display: true,
                prop: 'projectId',
                dicUrl: '/api/v4ward/project/getProjectList',
                props: { label: 'name', value: 'id' },
                disabled: true,
                required: true,
              },
              {
                type: 'input',
                label: '服务类型',
                span: 8,
                display: true,
                prop: 'moduleTypeName',
                disabled: true,
                required: true,
              },
              {
                type: 'select',
                label: '需求人',
                span: 8,
                display: true,
                rules: [{ required: true }],
                prop: 'contactName',
                required: true,
                disabled: true,
              },
              {
                type: 'select',
                label: '需求部门',
                span: 8,
                rules: [{ required: true }],
                display: true,
                prop: 'requireDeptName',
                disabled: true,
              },
              {
                type: 'input',
                label: '服务地点',
                span: 8,
                display: true,
                prop: 'areaName',
                required: true,
                rules: [{ required: true }],
                readonly: false,
              },
              {
                type: 'datetime',
                label: '期望到场时间',
                labelWidth: 120,
                span: 8,
                display: true,
                prop: 'expectStartTime',
                required: true,
                rules: [{ required: true }],
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                disabled: true,
              },
              {
                type: 'input',
                label: '需求来源',
                span: 8,
                // rules:[ { required: true,}],
                display: true,
                dataType: 'string',
                // dicUrl:'/api/blade-system/dict/dictionary?code=order_require_source',
                props: {
                  label: 'dictValue',
                  value: 'dictKet',
                },
                prop: 'sourceName',
                required: true,
              },
              {
                type: 'textarea',
                label: '需求描述',
                span: 24,
                rules: [{ required: true }],
                display: true,
                prop: 'description',
                required: true,
              },
              {
                type: 'input',
                label: '关键词',
                span: 8,
                rules: [{ required: true }],
                display: true,
                prop: 'keyWords',
                required: true,
                disabled: true,
              },
              {
                type: 'input',
                label: '需求附件',
                span: 24,
                // rules: [{ required: true }],
                display: true,
                formslot: true,
                typeslot: true,
                prop: 'attachList',
                // required: true,
              },
              {
                label: '评价信息',
                prop: 'evaluate',
                formslot: true,
                display: false,
              },
              {
                type: 'input',
                label: '服务项目',
                span: 24,
                formslot: true,
                typeslot: true,
                display: false,
                prop: 'serviceProject',
              },
              {
                type: 'input',
                label: '服务得分',
                span: 8,
                disabled: true,
                display: false,
                prop: 'serviceScore',
              },
            ],
          },
          {
            label: '完成信息',
            prop: '1604911406120_70102',
            arrow: true,
            collapse: true,
            display: false,
            column: [
              {
                prop: 'finishInformation',
                formslot: true,
                span: 24,
                labelWidth: 0,
              },
            ],
          },
        ],
      },
      requestDictionaryFlag: 0,
    };
  },
  created() {
    //this.getDictionary();
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.dialogFull = false;
    let bodyHight = document.body.clientHeight;

    this.dialogBodyHight = bodyHight - 400;
  },
  methods: {
    // 编辑提交
    submitRepaireUpdate() {
      this.$refs.Consumables.repairUpdate();
    },

    // 根据评价显示评价等级
    tag(level) {
      let tag = '';
      if (level == 2) {
        tag = '差';
      } else if (level == 3) {
        tag = '一般';
      } else if (level == 4) {
        tag = '好';
      } else if (level == 5) {
        tag = '非常好';
      } else if (level == 1) {
        tag = '很差';
      } else if (level == 0) {
        tag = '';
      }
      return tag;
    },
    getEvaluateType(type) {
      let name = '';
      this.evaluateTypeList.forEach((ele, index) => {
        if (ele.dictKey === type) {
          name = ele.dictValue;
        }
      });
      return name;
    },
    // 修改完服务项目时刷新接口
    serviceProjeptRefresh() {
      this.getServiceProjectByOrderId(); //获取服务项目信息
      this.getCourseLog(this.orderId); //获取历程信息
    },
    // 打开服务项目编辑框
    openSelectServiceProject() {
      this.$refs.editServiceProject.openSelectTree(
        this.orderDetailForm,
        this.checkedServiceProjectData
      );
    },
    // 打开验收确认弹窗
    openConfirmDialog() {
      console.log('打开确认');
      this.$refs.comfirmForm.openDialog(this.orderId);
    },
    // 打开验收确认弹窗
    openUrgeDialog() {
      console.log('打开确认');
      this.$refs.urgeForm.openDialog(this.orderId);
    },
    // 打开设置协同人框
    opensettingSynergy() {
      this.$refs.settingSynergy.openDialog(this.orderId);
    },
    // 打开回访
    openVisitDialog() {
      this.$refs.visitForm.openDialog(this.orderId, this.projectId);
    },
    // 打开弹窗获取数据
    openDialog(row, isEdit, type = 'list') {
      console.log('工单的row', row);
      this.orderRow = row;
      this.isEdit = isEdit;
      this.loading = 0;
      this.orderId = row.id;
      // 获取按钮
      if (type == 'list') {
        getOrderactionlist({ id: row.id }).then((res) => {
          this.orderActiveButton = res.data;
        });
      }

      // 获取工单详情
      if (this.requestDictionaryFlag >= 60) {
        this.getOrderDetail(row.id);
      }

      // 获取历程数据
      getDictData('order_operate_type').then((res) => {
        console.log(res);
        this.orderActionList = res.data;
        getCourseLog(row.id).then((res) => {
          res.data.forEach((ele) => {
            ele.orderActionName = this.tool.getDictionaryValue(
              this.orderActionList,
              'dictValue',
              'dictKey',
              ele.operateType
            );
            ele.fileList = [];
            ele.imgUrlData = [];
            ele.showDetail = false;
            ele.attachList.forEach((item) => {
              if (
                item.link.substring(item.link.length - 3) == 'png' ||
                item.link.substring(item.link.length - 3) == 'jpg'
              ) {
                ele.imgUrlData.push(item);
              } else {
                ele.fileList.push(item);
              }
            });
            this.loading += 20;
          });
          this.courseList = res.data;
        });
      });
    },
    // 获取历程信息
    getCourseLog(id) {
      getCourseLog(id).then((res) => {
        res.data.forEach((ele) => {
          ele.orderActionName = this.tool.getDictionaryValue(
            this.orderActionList,
            'dictValue',
            'dictKey',
            ele.operateType
          );
          ele.fileList = [];
          ele.imgUrlData = [];
          ele.showDetail = false;
          ele.attachList.forEach((item) => {
            if (
              item.link.substring(item.link.length - 3) == 'png' ||
              item.link.substring(item.link.length - 3) == 'jpg'
            ) {
              ele.imgUrlData.push(item);
            } else {
              ele.fileList.push(item);
            }
          });
        });
        this.courseList = res.data;
      });
    },
    // 获取服务项目信息
    getServiceProjectByOrderId() {
      let serviceProjectColumn = this.option.group[1];
      console.log(serviceProjectColumn);
      // let serviceScoreColumn = this.findObject(this.option.group[0].column,"serviceScore");
      if (
        this.orderDetailForm.workStatus == 6 ||
        this.orderDetailForm.workStatus == 7 ||
        this.orderDetailForm.workStatus == 8
      ) {
        serviceProjectColumn.display = true;
        // serviceScoreColumn.display = true;
      } else {
        serviceProjectColumn.display = false;
        // serviceScoreColumn.display = false;
      }

      getServiceProjectByOrderId({ orderId: this.orderId }).then((res) => {
        //获取已选择的服务项目
        console.log('服务项目');
        console.log(res);
        this.checkedServiceProjectData = res.data;
        let score = 0;
        this.checkedServiceProjectData.forEach((ele) => {
          //计算服务得分
          score += Number(ele.score) * Number(ele.consumeNum);
        });
        this.orderDetailForm.serviceScore = score;
      });
      isExecutePermission({ projectId: this.projectId, userId: this.userInfo.user_id }).then(
        (res) => {
          //获取修改服务项目权限
          if (res.data) {
            //true为可操作修改服务项目 false不显示不可操作服务项目
            this.serviceProjectEdit = true;
          } else {
            this.serviceProjectEdit = false;
          }
        }
      );
    },
    // 获取工单详情
    getOrderDetail(orderId) {
      this.loading = 30;
      getOrderDetail(orderId).then((res) => {
        // this.orderActiveButton = res.data.actionType;
        this.orderDetailForm = res.data.orderDetails[0];
        this.projectId = this.orderDetailForm.projectId;
        this.orderDetailForm.fileList = [];
        this.orderDetailForm.imgUrlData = [];
        this.moduleType = this.orderDetailForm.moduleType;
        this.loading += 20;
        this.orderDetailForm.moduleTypeName = this.tool.getDictionaryValue(
          this.moduleTypeList,
          'dictValue',
          'dictKey',
          this.orderDetailForm.moduleType
        );
        // if (this.orderDetailForm.subModuleId) {
        //   // this.orderDetailForm.sunmoduleTypeName = this.tool.getDictionaryValue(this.moduleTypeList,'dictValue','dictKey',this.orderDetailForm.subModuleId);
        //   if (this.option.group[0].column[1].prop != "subModuleName") {
        //     let temObj = {
        //       type: "input",
        //       label: "服务类型",
        //       span: 8,
        //       display: true,
        //       prop: "moduleTypeName",
        //       disabled: true,
        //       required: true,
        //     };
        //     this.option.group[0].column.splice(1, 0, temObj);
        //   }
        // }
        this.orderDetailForm.sourceName = this.tool.getDictionaryValue(
          this.orderRequireSourcelist,
          'dictValue',
          'dictKey',
          this.orderDetailForm.source
        );
        // this.orderDetailForm.areaName = this.tool.getDictionaryValue(
        //   res.data.dictList,
        //   "dictValue",
        //   "dictKey",
        //   this.orderDetailForm.areaId
        // );
        if (this.orderDetailForm.requireMainPhone) {
          //如果有电话号码需要将电话号码拼接在姓名后面
          this.orderDetailForm.contactName =
            this.orderDetailForm.contactName +
            ' (' +
            this.orderDetailForm.requireMainPhone +
            ')';
        }
        this.orderDetailForm.statusName = this.tool.getDictionaryValue(
          this.orderStatusNameList,
          'dictValue',
          'dictKey',
          this.orderDetailForm.workStatus
        );

        this.evaluateInfo = res.data.evaluate;
        this.evaluateDetailList = res.data.evaluate.detailList;
        console.log('this.evaluateInfo=================>', this.evaluateInfo);
        console.log('this.evaluateDetailList=================>', this.evaluateDetailList);

        getProjectDict({ projectId: this.projectId, code: 'project_order_evaluate_target' }).then(
          (res) => {
            console.log(res.data);
            this.evaluateTypeList = res.data;
          }
        );
        //获得服务项目

        this.getServiceProjectByOrderId();
        this.dialogVisible = true;
      });
    },
    // 点击历程上的详情
    clickDetail(item) {
      this.$set(item, 'showDetail', !item.showDetail);
      let list = this.courseList;
      this.courseList = 12312;
      this.courseList = list;
    },
    // 获取各种字典
    async getDictionary() {
      // 获取项目
      await getprojectList().then((res) => {
        this.projectList = res.data;
        this.requestDictionaryFlag += 20;
        // if(this.requestDictionaryFlag>=60){
        //     this.getOrderDetail();
        //  }
      });
      // 获取服务类型
      await getDictData('out_order_module_type').then((res) => {
        this.moduleTypeList = res.data;
        this.requestDictionaryFlag += 20;
      });
      // out_order_work_status 获取工单状态
      await getDictData('out_order_work_status').then((res) => {
        this.orderStatusNameList = res.data;
        this.requestDictionaryFlag += 20;
      });
      // order_require_source 获取需求来源
      await getDictData('order_require_source').then((res) => {
        this.orderRequireSourcelist = res.data;
        this.requestDictionaryFlag += 20;
      });
    },
    // 下载文件接口
    downloadFile(file) {
      // data 是接口地址
      downloadFile(file.link, file.originalName);
    },
    handleClose(done) {
      if (this.isEdit && done != 'edit') {
        this.$confirm('确认关闭?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          // 调用外层刷新功能
          this.$emit('refresh');
          // 关闭大弹窗
          this.dialogVisible = false;
          // done();
        });
      } else {
        // 调用外层刷新功能
        this.$emit('refresh');

        // this.visitDialog = false;
        // 清空按钮表单
        this.delayForm = {
          attachList: [],
        };
        this.recoverForm = {};
        this.finishForm = {
          attachList: [],
        };
        this.outsourcingForm = {};
        this.scrapForm = {
          attachList: [],
        };
        this.complaintForm = {};
        this.assignForm = {};
        this.robOrderForm = {};
        this.startOrderForm = {
          attachList: [],
        };
        this.cancelForm = {
          attachList: [],
        };
        this.repairsForm = {
          attachList: [],
        };
        this.evaluateForm = {};
        this.visitForm = {};
        this.printForm = {};

        // 关闭按钮弹窗
        (this.delayDialog = false), //延迟
          (this.recoverDialog = false), //恢复
          (this.scrapDialog = false), //报废
          (this.outsourcingDialog = false), //外委
          (this.repairsDialog = false), //报修
          (this.complaintDialog = false), //转办
          (this.assignDialog = false), //指派
          (this.robOrderDialog = false), //抢单
          (this.startOrderDialog = false), //开始
          (this.cancelDialog = false), //取消
          (this.evaluateDialog = false), //评价
          (this.visitDialog = false), //回访
          (this.printDialog = false), //打印
          // 关闭大弹窗
          (this.dialogVisible = false);
        done();
      }
    },
    // 打印弹窗
    openPrintDialog(falg) {
      if (falg) {
        this.$refs.print.openDialog(this.orderDetailForm);
      } else {
        (this.printLoading = true), (this.printDialog = true);
        print({ orderId: this.orderId }).then((res) => {
          this.printForm = res.data;
          this.printLoading = false;
        });
      }
    },
    // 打印确认
    printSubmit() {
      setTimeout(() => {
        this.$Print({
          id: 'print',
          html: document.getElementById('print').innerHTML,
        });
        this.printDialog = false;
      }, 100);
    },
    // 关闭打印预览弹窗
    closePrintDialog(done) {
      done();
    },

    // 评价弹窗
    openEvaluateDialog(title) {
      this.$refs.Evaluate.openDialog({
        orderId: this.orderId,
        title: title,
        projectId: this.projectId,
      });
    },

    // 延迟弹窗
    openDelayDialog(title) {
      this.$refs.Delay.openDialog({ orderId: this.orderId, title: title, orderRow: this.orderRow });
    },

    // 恢复弹窗
    openRecoverDialog(title) {
      this.$refs.Recover.openDialog({
        orderId: this.orderId,
        title: title,
        orderRow: this.orderRow,
      });
    },

    // 完成弹窗
    openFinishDialog(actionType) {
      this.$refs.finish.openDialog({
        subModuleId: this.orderDetailForm.subModuleId,
        taskId: this.orderDetailForm.businessData.taskId,
        orderId: this.orderId,
        actionType: actionType,
        projectId: this.projectId,
        orderRow: this.orderRow,
      });
    },
    // 外委弹窗
    openOutsourcingDialog(index) {
      this.$refs.Outsourcing.openDialog({
        orderId: this.orderId,
        actionType: index,
        projectId: this.projectId,
        orderRow: this.orderRow,
      });
    },
    // 报废弹窗
    openScrapDialog(title) {
      this.$refs.Scrap.openDialog({ orderId: this.orderId, title: title, orderRow: this.orderRow });
    },
    // 报修弹窗
    openRepairsDialog(index) {
      getRemarkList({ orderId: this.orderId, actionType: index }).then((res) => {
        this.$refs.repairsFormRemarkModel.setRemarkList(res.data);
      });
      // 需求人员
      getUserListByDepartmentId().then((res) => {
        this.requireUserList = res.data;
      });
      this.repairsDialog = true;
    },
    // 报修表单  -- 项目名称切换
    changeHandler_(value) {
      lazyAreaTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
      });
    },
    // 报修表单  --需求区域数据
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({ parentId: id, projectId: this.repairsForm.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
    },
    editAreaNodeTreeClick_(node) {
      if (parseInt(node.nodeType) == 1) {
        // this.$message.error();
        return;
      }
      setTimeout(() => {
        let nodeId = node.id;
        let nodeTitle = node.name;
        // this.form.areaName = nodeTitle;
        // this.form.areaId = nodeId;

        this.repairsForm = Object.assign({}, this.repairsForm, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
      }, 0);
    },
    changeRequireUserHandler_(val) {
      let tempRequiredUserName = '';
      this.requireUserList.forEach((ele, index) => {
        if (val === ele.id) {
          tempRequiredUserName = ele.realName;
        }
      });
      this.repairsForm.contactName = tempRequiredUserName;
    },
    // 报修提交
    repairsFormSubmit(form, done) {
      form.projectId = this.projectId;
      form.moduleType = this.moduleType;
      form.oldOrderId = this.orderId;
      form.moduleJson = '{}';
      form.areaId = this.orderDetailForm.areaId;
      form.source = '4';
      form.requireMainId = this.userInfo.user_id;
      form.contactName = this.userInfo.user_name;
      form.deptId = this.orderDetailForm.deptId;
      repairs(form)
        .then((res) => {
          if (res.msg == '操作成功') {
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.dialogVisible = false;
            this.repairsDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log('关闭历程表');
          });
          this.repairsDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 报修提交报错
    repairsFormError(done) {
      done();
    },
    // 关闭报修弹窗
    closeRepairsDialog(done) {
      this.repairsForm = {
        attachList: [],
      };
      this.repairsDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 取消弹窗
    openCancelDialog(index) {
      this.$refs.cencel.openDialog({ orderId: this.orderId, orderRow: this.orderRow });
    },

    // 开始弹窗
    openStartOrderDialog(index) {
      this.$refs.start.openDialog({
        orderId: this.orderId,
        actionType: index,
        projectId: this.projectId,
        orderRow: this.orderRow,
      });
    },
    // 接受弹窗
    openRobOrderDialog(title) {
      this.$refs.Receive.openDialog({
        orderId: this.orderId,
        title: title,
        orderRow: this.orderRow,
      });
    },
    // 接受提交
    robOrderFormSubmit(form, done) {
      form.orderId = this.orderId;
      accept(form)
        .then((res) => {
          if (res.msg == '操作成功') {
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.robOrderDialog = false;
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log('关闭历程表');
          });
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 抢单/接受提交报错
    robOrderFormError(done) {
      done();
    },
    // 关闭抢单/接受弹窗
    closeRobOrderDialog(done) {
      this.robOrderForm = {};
      this.robOrderDialog = false;
      if (done) {
        done();
      }
      done();
    },

    // 打开派单弹窗
    openAssignDialog(index) {
      this.$refs.Appoint.openDialog({
        orderId: this.orderId,
        subModuleId: this.orderDetailForm.subModuleId,
        orderRow: this.orderRow,
      });
    },
    // 抢单弹窗
    openGrabSingleDialog(index) {
      this.$refs.GrabSingle.openDialog({ orderId: this.orderId, orderRow: this.orderRow });
    },

    // 打开转办弹窗
    openComplaintDialog(index) {
      console.log('this.orderDetailForm ==>', this.orderDetailForm);
      this.$refs.complaint.openDialog(
        this.orderId,
        this.orderDetailForm.subModuleId,
        this.orderRow
      );
      return;
    },
  },
};
</script>
<style lang="scss" scoped>
.test {
  justify-content: space-between;
  justify-content: flex-end;
  flex-shrink: 1;
  flex-grow: 1;
}
.order-detail {
  flex-shrink: 1;
  flex-grow: 1;
}
.course {
  flex-shrink: 0;
  flex-grow: 0;
  width: 260px;
  padding: 20px;
  padding-right: 10px;
  border-left: 2px solid #eee;
  overflow: hidden;
  overflow-y: auto;
}
td {
  // border: 1px solid #999;
  height: 40px;
  line-height: 40px;
  min-width: 80px;
  text-align: center;
}
.add-height {
  height: 120px;
  text-align: left;
  padding: 10px;
  text-indent: 2rem;
}
.title-name {
  font-weight: bold;
}
.add-width {
  width: 100px;
}
.step-icon {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  // background-color: #eee;
  border-radius: 50%;
}
.fileStyle {
  padding: 5px 5px;
  background-color: #eee;
  margin: 5px 0px;
}
.fileStyle:hover {
  // background-color:#333;
  position: relative;
  top: -1px;
  left: -1px;
}
</style>
>
